import { useSyncExternalStore } from 'react'
import { useText } from '../i18n.js'
import type { CameraStore } from './CameraStore.js'

/**
 * Eigene kleine Komponente, damit die Zoomanzeige den Rest der Oberfläche nicht
 * mitrendert. Der Snapshot ist eine gerundete Ganzzahl — solange die Prozentzahl
 * gleich bleibt, passiert gar nichts.
 */
export function ZoomControls({
  camera,
  onFit,
}: {
  camera: CameraStore
  onFit: () => void
}): React.ReactElement {
  const percent = useSyncExternalStore(camera.subscribe, () =>
    Math.round(camera.getCamera().zoom * 100),
  )

  const t = useText()

  const zoomBy = (factor: number): void => {
    const size = camera.getSize()
    camera.zoomAt({ x: size.width / 2, y: size.height / 2 }, factor)
  }

  return (
    <div className="zoom-controls">
      <button className="button ghost icon" onClick={() => zoomBy(0.8)} aria-label={t('zoom.out')}>
        −
      </button>
      <button
        className="button ghost zoom-value"
        onClick={() => camera.animateTo({ ...camera.getCamera(), zoom: 1 }, 300)}
        title={t('zoom.reset')}
      >
        {percent}%
      </button>
      <button className="button ghost icon" onClick={() => zoomBy(1.25)} aria-label={t('zoom.in')}>
        +
      </button>
      <button className="button ghost" onClick={onFit} title={t('zoom.fitTitle')}>
        {t('zoom.fit')}
      </button>
    </div>
  )
}
